import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';
import * as _ from 'lodash';



@Injectable({
  providedIn: 'root'
})

export class AuthService {
  constructor(
    private httpClient: HttpClient
  ) { }

  // login api
  login(logTransactionId, data: any) {
    let headers = new HttpHeaders({'logTransactionId': logTransactionId });
    let options = { headers: headers };
    return this.httpClient.post(`${environment.AGGREGATOR_API_ENDPOINT}/users/login`, data, options)
  }

  logout() {
    const query = new HttpParams().set(
      'access_token',
      localStorage.getItem('token')
    );
    return this.httpClient.post(`${environment.AGGREGATOR_API_ENDPOINT}/users/logout/`, {}, { params: query });
  }

  getUserDetails(id: string, accessToken: string) {
    const query: any = {};
    query.filter = JSON.stringify({
      include: ['roles']
    });
    query.access_token = accessToken;
    return this.httpClient.get(`${environment.AGGREGATOR_API_ENDPOINT}/users/${id}`, { params: query }).pipe(
      map((result: any) => {
        localStorage.setItem('userDetails', JSON.stringify(result.response));
        return result.response;
      })
    );
  }

  getCurrentUser() {
    const user = localStorage.getItem('userDetails');
    return JSON.parse(user);
  }
}
